import { AbstractLobbyDetailVO } from "../gamevo/AbstractLobbyDetailVO";

import Event = createjs.Event;

export class Poker2LobbyDetailEvent extends Event {
    public static SHOW_TOURNAMENT_DETAIL: string = "showTournamentDetail";
    public static SHOW_TOURNAMENT_TABLE_DETAIL: string = "showTournamentTableDetail";
    public static HIDE_DETAIL: string = "hideDetail";

    public lobbyDetailVO: AbstractLobbyDetailVO;

    constructor(type: string, lobbyDetailVO: AbstractLobbyDetailVO = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.lobbyDetailVO = lobbyDetailVO;
    }
}
